import { useState } from 'react';
import './LikeButton.css';

const STORAGE_KEY = 'liked_posts';

function getLikedSlugs() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function LikeButton({ slug, initialLikes = 0 }) {
  const [liked, setLiked] = useState(() => getLikedSlugs().includes(slug));

  const count = initialLikes + (liked ? 1 : 0);

  function toggle() {
    const slugs = getLikedSlugs();
    if (liked) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(slugs.filter((s) => s !== slug)));
    } else {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...slugs, slug]));
    }
    setLiked((l) => !l);
  }

  return (
    <button className={`like-btn${liked ? ' like-btn--liked' : ''}`} onClick={toggle} aria-label={liked ? 'Unlike this post' : 'Like this post'}>
      <svg className="like-btn-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
      <span className="like-btn-count">{count}</span>
    </button>
  );
}

export default LikeButton;
